import TYPES from '@/modules/shared/types';

// Domain
import { OnBoardingStepEntity } from '../../../../domain/entities/on-boarding-step-entity';
import { SearchOnBoardingStepRepository } from '../../../../domain/repositories';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class SearchOnBoardingStepHttpRepository implements SearchOnBoardingStepRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/investment/on-boarding-step/?pagination_all_items=true&investment_provider_id={INVESTMENT_PROVIDER_ID}`;

  execute(investment_provider_id: string): Promise<Array<OnBoardingStepEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{INVESTMENT_PROVIDER_ID}', investment_provider_id))
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
